import { operationsJournalMock } from "../mock/operationsJournalMock";

/**
 * Дополнительные фильтры из меню «Добавить фильтр».
 * fields — поля строки, по которым ищется совпадение (аналитика ищется и в Дт, и в Кт).
 */
const FILTER_DEFINITIONS = [
  { key: "accountDt", label: "Счёт Дт", fields: ["accountDt"] },
  { key: "accountKt", label: "Счёт Кт", fields: ["accountKt"] },
  { key: "project", label: "Проект", fields: ["projectDt", "projectKt"] },
  { key: "department", label: "Отделение", fields: ["departmentDt", "departmentKt"] },
  { key: "counterparty", label: "Контрагент", fields: ["counterpartyDt", "counterpartyKt"] },
  { key: "employee", label: "Сотрудник", fields: ["employeeDt", "employeeKt"] },
  { key: "contract", label: "Договор", fields: ["contractDt", "contractKt"] },
  { key: "articleOpiu", label: "Статья ОПИУ", fields: ["articleOpiuDt", "articleOpiuKt"] },
  { key: "cfoOpiu", label: "ЦФО ОПИУ", fields: ["cfoOpiuDt", "cfoOpiuKt"] },
  { key: "articleDds", label: "Статья ДДС", fields: ["articleDdsDt", "articleDdsKt"] },
  { key: "cfoDds", label: "ЦФО ДДС", fields: ["cfoDdsDt", "cfoDdsKt"] },
  { key: "cashAccount", label: "Денежный счёт", fields: ["cashAccountDt", "cashAccountKt"] },
  { key: "workType", label: "Вид работ", fields: ["workTypeDt", "workTypeKt"] },
  { key: "nomenclature", label: "Номенклатура", fields: ["nomenclatureDt", "nomenclatureKt"] },
  { key: "fixedAsset", label: "Основное средство", fields: ["fixedAssetDt", "fixedAssetKt"] },
  {
    key: "intangibleAsset",
    label: "Нематериальный актив",
    fields: ["intangibleAssetDt", "intangibleAssetKt"],
  },
  { key: "budgetVersion", label: "Версия бюджета", fields: ["budgetVersion"] },
  { key: "amount", label: "Сумма", type: "range" },
];

const collectOptions = (fields) =>
  [
    ...new Set(
      operationsJournalMock.flatMap((row) =>
        fields.map((field) => row[field]).filter((value) => value != null && value !== "")
      )
    ),
  ].sort((a, b) => String(a).localeCompare(String(b), "ru"));

/** Фильтры без единого значения в данных в меню не показываются */
export const EXTRA_FILTERS = FILTER_DEFINITIONS.map((filter) =>
  filter.type === "range" ? filter : { ...filter, options: collectOptions(filter.fields) }
).filter((filter) => filter.type === "range" || filter.options.length > 0);

export const EXTRA_FILTER_BY_KEY = Object.fromEntries(
  EXTRA_FILTERS.map((filter) => [filter.key, filter])
);

export const EMPTY_RANGE = { from: null, to: null };

/** Значение фильтра задано (добавленный, но не заполненный фильтр ни на что не влияет) */
export const isExtraFilterActive = (key, value) => {
  if (EXTRA_FILTER_BY_KEY[key]?.type === "range") {
    return value?.from != null || value?.to != null;
  }
  return Boolean(value);
};

export const matchesExtraFilters = (row, filters) =>
  Object.entries(filters).every(([key, value]) => {
    if (!isExtraFilterActive(key, value)) return true;
    const filter = EXTRA_FILTER_BY_KEY[key];
    if (filter.type === "range") {
      if (value.from != null && row.amount < value.from) return false;
      if (value.to != null && row.amount > value.to) return false;
      return true;
    }
    return filter.fields.some((field) => row[field] === value);
  });
